import React from "react";
import { Navigate } from "react-router-dom";
import { useLoginRedirect } from "../../contexts/app/useLoginRedirect";
import { useAuth } from "../../contexts/api";

interface ProtectedRoutesProps {
  children: React.ReactNode;
}

export const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({ children }) => {
  const { token } = useAuth();
  const { buildLoginUrl } = useLoginRedirect();
  if (!token) {
    return <Navigate to={buildLoginUrl(undefined)} replace />;
  }
  return <>{children}</>;
};
